import axios from 'axios';
import querystring from 'querystring';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveProjectItemsByProjectId(context, projectId) {
      try {
        // eslint-disable-next-line max-len
        const data = await axios.get(`/cfa-data/user-logged-in/projects/${projectId}/items`, { withCredentials: true });
        return data.data;
      } catch (error) {
        throw error;
      }
    },
    async retrieveProjectsInformation(context, params) {
      try {
        const query = querystring.stringify(params);
        // eslint-disable-next-line max-len
        const data = await axios.get(`/cfa-data/user-logged-in/projects/information?${query}`, { withCredentials: true });
        return data.data;
      } catch (error) {
        throw error;
      }
    },
    async retrieveProjectsInformationByProjectId(context, { projectId, params, sharedToken }) {
      try {
        const query = querystring.stringify(params);
        const config = { withCredentials: true };
        if (sharedToken) config.headers = { Authorization: sharedToken };
        // eslint-disable-next-line max-len
        const data = await axios.get(`/cfa-data/user-logged-in/projects/information/${projectId}?${query}`, config);
        return data.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
